export const AppConfig = {
  isDebug: process.env.NODE_ENV !== 'production',
  trialExpireDays: 14,
  cookieDomain: process.env.COOKIE_DOMAIN,
};
